import request from "./request"

export function addBehaviorEvents(events) {
  return request.post("/analytics/events_add", { events: JSON.stringify(events) }, { silentError: true, timeout: 8000 })
}
